import axios from "axios";
import logout from "@/util/logout";
import store from "@/store";
import messages from "../languages/index";
let lang = localStorage.getItem("language");
export default {
  install(Vue) {
    // Internacionalization Language
    let language = localStorage.getItem("language") || "pt";

    // Internacionalization GMT
    let gmt = new Date();
    gmt.getTimezoneOffset() / 60;
    let sub = String(gmt);
    sub = sub.slice(28, 31) + ":" + sub.slice(31, 33);

    // Retrieve subdomain
    // Config baseurl axios
    let hostName = window.location.hostname;
    let networkLocal = hostName.split(".")[0];

    let baseURL = "";

    if (
      hostName == "localhost" ||
      hostName == "backoffice.sys.bet" ||
      networkLocal == "192"
    ) {
      // baseURL = "https://v2.envrelease.com";
      // baseURL = "http://localhost:9090";
      baseURL = "https://apidev.sga.bet";
    } else if (hostName == "homolog-backoffice.sga.bet") {
      baseURL = "https://apiv2dev.sga.bet";
    } else {
      baseURL = "https://v2.envrelease.com";
    }

    Vue.prototype.$axios = axios.create({
      baseURL,
      headers: {
        "Content-Type": "multipart/form-data",
        "x-api-key": process.env.VUE_APP_API_KEY,
        language: language,
        gmt: sub,
      },
    });

    const refreshToken = () => {
      if (
        !JSON.parse(localStorage.getItem("auth")) ||
        window.location.href.includes("/auth/login")
      ) {
        return;
      }

      const now = new Date();
      const expirationDate = new Date(
        JSON.parse(localStorage.getItem("tokenExpirationDate"))
      );

      const difference = expirationDate.getTime() - now.getTime();
      const differenceInMinutes = Math.round(difference / 60000);
      const lessThanFiveMinutesOfToken = 5 > differenceInMinutes > 0;

      if (lessThanFiveMinutesOfToken) {
        let level = localStorage.getItem("level");

        if (level === "collaborator") {
          level = "colab";
          return;
        }

        clearTimeout(JSON.parse(localStorage.getItem("refreshId")));

        const refreshId = setTimeout(() => {
          fetch(`${baseURL}/${level}/token/refresh`, {
            headers: {
              "Application-Authorization":
                Vue.prototype.$axios.defaults.headers.common[
                  "Application-Authorization"
                ],
              "x-api-key":
                "02ff96c8f50ce6a488812146d448a04b2e2358dd45d0dbb59824",
            },
          })
            .then((res) => res.json())
            .then((data) => {
              Vue.prototype.$axios.defaults.headers.common[
                "Application-Authorization"
              ] = data.dados.token;

              localStorage.setItem("token", data.dados.token);
              const date = data.dados.token_exp.replace(/-/g, "/");
              localStorage.setItem("tokenExpirationDate", JSON.stringify(date));
            });
        }, 2000);

        localStorage.setItem("refreshId", JSON.stringify(refreshId));
      }
    };

    const handleSuccess = (response) => {
      refreshToken();

      store.commit("resetCounterOfErrors500");
      store.commit("setFeedbackProgress", false);
      store.commit("setSave", false);
      store.commit("DisabledSave", false);

      return response;
    };

    const handleError = (error) => {
      // Erro 401 - Token Expired
      if (error.response.status === 401) {
        store.commit("resetCounterOfErrors500");

        store.commit("setFeedbackSnack", {
          msg: error.response.data.messages.error,
          color: "danger",
        });
        logout();
      }

      // Erro 400 - No data, Alert Snack
      if (error.response.status === 400) {
        refreshToken();

        store.commit("resetCounterOfErrors500");

        if (error.response.config.url.includes("listMainEvents")) {
          return;
        }

        const msg = error.response.data.messages;
        store.commit("setFeedbackSnack", {
          status: 400,
          msg: msg ? msg.error : messages[lang].noDataFount,
          color: "warning",
        });
      }

      // Erro 500 - No data, Alert Snack
      if (error.response.status >= 500) {
        refreshToken();

        store.commit("setCounterOfErrors500");

        store.commit("setFeedbackSnack", {
          msg: messages[lang].unexpectedErrorOccured,
          color: "error",
        });
      }

      store.commit("setFeedbackProgress", false);
      store.commit("setSave", false);
      store.commit("DisabledSave", false);
      return Promise.reject(error);
    };

    // Interceptors
    Vue.prototype.$axios.interceptors.response.use(handleSuccess, handleError);
  },
};
